// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-section-label {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.78rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: var(--bs-primary);
    border-bottom: 1px solid var(--color-border-soft);
    padding-bottom: 0.6rem;
    margin-bottom: 1rem;
}

.supervisors-box {
    border: 1px solid var(--color-border);
    border-radius: var(--bs-border-radius);
    padding: 0.85rem 1rem;
    background: #fff;
    max-height: 220px;
    overflow-y: auto;
}

.supervisors-box--disabled {
    background: var(--color-surface-alt);
}`, "",{"version":3,"sources":["webpack://./src/assets/css/createUser.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,wBAAwB;IACxB,iDAAiD;IACjD,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;IACrC,sCAAsC;IACtC,qBAAqB;IACrB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;AACxC","sourcesContent":[".form-section-label {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    font-size: 0.78rem;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    color: var(--bs-primary);\n    border-bottom: 1px solid var(--color-border-soft);\n    padding-bottom: 0.6rem;\n    margin-bottom: 1rem;\n}\n\n.supervisors-box {\n    border: 1px solid var(--color-border);\n    border-radius: var(--bs-border-radius);\n    padding: 0.85rem 1rem;\n    background: #fff;\n    max-height: 220px;\n    overflow-y: auto;\n}\n\n.supervisors-box--disabled {\n    background: var(--color-surface-alt);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
